
import { motion, useTransform, type MotionValue } from "framer-motion";
import {
  FEATURED_WORKLOAD,
  SNAP_FADE,
} from "../keyframe-data";
import type { KeyframeBand } from "../types";
import { PERSONAL_DATA_NODES, getNode } from "../graph-layout";
import { WorkloadZone } from "../elements/workload-zone";
import { ClassificationChip, classificationChipWidth } from "../elements/classification-chip";

const PERSONAL_DATA_LABEL = "PERSONAL DATA";

interface Props {
  progress: MotionValue<number>;
  /** Beat 4 band. */
  band: KeyframeBand;
  /** Beat 5 band — beat 4 fades out at its start. */
  nextBand: KeyframeBand;
}

export function Beat4Workload({ progress, band, nextBand }: Props) {
  // Snap-style transitions — short fade windows so each beat reads as discrete.
  // Zone fades in early in beat 4, then fades out at the start of beat 5.
  const FADE = SNAP_FADE;
  const zoneOpacity = useTransform(
    progress,
    [band.start, band.start + FADE, nextBand.start, nextBand.start + FADE],
    [0, 1, 1, 0],
  );
  // Personal-data chips persist from beat 4 through end of pin 2.
  const chipOpacity = useTransform(
    progress,
    [band.start + FADE, band.start + FADE * 2],
    [0, 1],
  );

  return (
    <motion.g data-beat="4" aria-hidden="true">
      <motion.g style={{ opacity: zoneOpacity }}>
        <WorkloadZone label={FEATURED_WORKLOAD.label} />
      </motion.g>

      {/* Classification chips — uniformly above each PII node */}
      <motion.g style={{ opacity: chipOpacity }}>
        {PERSONAL_DATA_NODES.map((id) => {
          const n = getNode(id);
          const w = classificationChipWidth(PERSONAL_DATA_LABEL);
          return (
            <ClassificationChip
              key={`chip-${id}`}
              x={n.cx - w / 2}
              y={n.y - 28}
              label={PERSONAL_DATA_LABEL}
            />
          );
        })}
      </motion.g>
    </motion.g>
  );
}
